import { Button, Typography } from '@cobliteam/ui/components';
import type React from 'react';
import type { TooltipRenderProps } from 'react-joyride';

import { Analytics } from '@cobliteam/analytics';
import Icon from '@cobliteam/ui/icons';

import SidebarButtonPreview from './image.png';

interface SidebarCardProps {
  title: string;
  description: string;
  stepIndex: number;
  totalSteps: number;
  closeFloater: () => void;
}

export function SidebarCard(props: TooltipRenderProps) {
  const {
    step: { title, content },
    index,
    size,
    isLastStep,
    closeProps,
    primaryProps,
    backProps,
  } = props;

  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    Analytics.track('Joyride - Click - Close', { stepIndex: index + 1 });
    closeProps.onClick(e);
  };

  const handleNext = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    Analytics.track('Joyride - Click - Next', { stepIndex: index + 1 });
    primaryProps.onClick(e);
  };

  const handlePrevious = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    Analytics.track('Joyride - Click - Previous', { stepIndex: index + 1 });
    backProps.onClick(e);
  };

  const showPrevious = index > 0;

  return (
    <div className='relative flex w-[369px] flex-row items-center bg-white p-5'>
      <Button variant='ghost' color='default' className='absolute top-0 right-0' icon={<Icon name='x' />} onClick={handleClose} />
      <div className='mt-4 flex flex-col gap-5'>
        <div className='flex flex-col gap-3 text-balance'>
          <Typography variant='heading-lg' className='text-center'>
            {title}
          </Typography>
          <Typography variant='text-md' className='text-center'>
            {content}
          </Typography>
          <div className='mt-4 flex flex-row items-center justify-between'>
            <Typography variant='description-list-default' color='secondary'>
              {`${index + 1} de ${size}`}
            </Typography>

            <div className='flex flex-row items-center gap-2'>
              {showPrevious && (
                <Button size='sm' variant='text' color='default' onClick={handlePrevious}>
                  Voltar
                </Button>
              )}
              {isLastStep ? (
                <Button
                  size='sm'
                  onClick={(e) => {
                    Analytics.track('Joyride - Click - Complete');
                    closeProps.onClick(e);
                  }}
                >
                  Concluir
                </Button>
              ) : (
                <Button size='sm' onClick={handleNext}>
                  Próximo
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export interface SidebarJoyrideCardGroupsProps {
  stepIndex: number;
  totalSteps: number;
  closeFloater: () => void;
}

export function GlobalFilterCard({ stepIndex, totalSteps, closeFloater }: SidebarJoyrideCardGroupsProps) {
  return (
    <div className='flex w-96 flex-row items-center gap-5'>
      <Button
        variant='text'
        color='default'
        className='absolute top-2 right-2'
        icon={<Icon name='x' />}
        onClick={() => {
          Analytics.track('Joyride - Click - CloseFilter');
          closeFloater();
        }}
      />
      <div className='flex flex-col gap-5'>
        <img src={SidebarButtonPreview} className='h-18 w-64 rounded-md' alt='Filtro Global' />
        <div className='flex flex-col gap-3'>
          <Typography variant='description-title'>Conheça o novo filtro de grupos de veículos!</Typography>
          <Typography variant='description-list-default'>
            Agora você pode filtrar mais fácil seus grupos com o novo filtro! O grupo filtrado irá refletir em todas as páginas do painel.
          </Typography>
          <div className='flex flex-row items-center justify-between'>
            <Typography variant='description-list-default' color='secondary'>
              {`${stepIndex} de ${totalSteps}`}
            </Typography>
            <Button
              onClick={() => {
                Analytics.track('Joyride - Click - CompleteFilter');
                closeFloater();
              }}
            >
              Concluir
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
